import React from 'react';
import SearchIcon from 'svg/SearchIcon';
import Link from 'components/Link';
import classNames from 'styles/utils/classNames';

interface Props {
  title: string;
  href: string;
  className?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}

export default function IconActionLink({ title, href, className, onClick, icon }: Props) {
  return (
    <div className={classNames('flex h-full items-center', className)}>
      <Link
        onClick={(e) => {
          if (onClick) {
            e.preventDefault();
            onClick();
          }
        }}
        href={href}
        className="flex cursor-pointer flex-col items-center justify-center gap-ds-md"
      >
        <div className="grid  h-[3.5rem] w-[3.5rem] place-items-center rounded-full bg-color-brand-primary shadow-[0px_4px_20px_0px_rgba(0,0,0,0.16)] max-sm:h-10 max-sm:w-10">
          {icon || <SearchIcon className="h-5 w-5 text-color-text-lightmode-invert" />}
        </div>
        <span className="max-sm:typography-product-button-label-small typography-product-button-label-medium">
          {title}
        </span>
      </Link>
    </div>
  );
}
